import { html, LitElement, css, unsafeCSS } from 'lit';
import styles from './progressBar.scss?inline';
import { classMap } from 'lit/directives/class-map.js';
import { styleMap } from 'lit/directives/style-map.js';
import { ATTRIBUTES, PROPS } from './constants';

export default class SotbitProgressBar extends LitElement {
    static styles = css`
        ${unsafeCSS(styles)}
    `;

    static properties = {
        current: { type: Number },
        currentFormat: { type: String, attribute: ATTRIBUTES.CURRENT_FORMAT },
        limit: { type: Number },
        showValue: { type: Boolean, attribute: ATTRIBUTES.SHOW_VALUE },
        labelTitle: { type: String, attribute: ATTRIBUTES.LABEL_TITLE },
        labelValue: { type: String, attribute: ATTRIBUTES.LABEL_VALUE },
        isLabelHidden: { type: Boolean, state: true },
    };

    constructor() {
        super();

        this.current = 0;
        this.limit = 100;
        this.showValue = false;
        this.labelText = '';
        this.isLabelHidden = false;
    }

    updated(changedProperties) {
        if (
            this.showValue &&
            (changedProperties.has(PROPS.CURRENT) ||
                changedProperties.has(PROPS.LIMIT) ||
                changedProperties.has(PROPS.SHOW_VALUE))
        ) {
            this.checkLabelCollision();
        }
    }

    checkLabelCollision() {
        requestAnimationFrame(() => {
            if (this.current >= this.limit) {
                if (this.isLabelHidden) {
                    this.isLabelHidden = false;
                }

                return;
            }

            const labelElement = this.shadowRoot.querySelector('.value-label');
            const containerElement = this.shadowRoot.querySelector('.progress-bar');

            if (!labelElement || !containerElement) {
                if (!this.isLabelHidden) {
                    this.isLabelHidden = true;
                }

                return;
            }

            const labelWidth = labelElement.offsetWidth;
            const containerWidth = containerElement.offsetWidth;
            const thumbPosition = (this.current / this.limit) * containerWidth;

            const isCollidingLeft = thumbPosition < labelWidth;
            const isCollidingRight = thumbPosition + labelWidth > containerWidth;
            const shouldBeHidden = isCollidingLeft || isCollidingRight;

            if (shouldBeHidden !== this.isLabelHidden) {
                this.isLabelHidden = shouldBeHidden;
            }
        });
    }

    render() {
        const MAX_PERCENTAGE = 100;
        const percentage = (this.current / this.limit) * MAX_PERCENTAGE;
        const isOverLimit = this.current > this.limit;
        const fillWidth = Math.min(percentage, MAX_PERCENTAGE);

        const fillClasses = {
            'progress-bar-fill': true,
            'over-limit': isOverLimit,
        };

        const fillStyles = {
            width: `${fillWidth}%`,
        };

        const thumbWrapperStyles = {
            left: `${fillWidth}%`,
        };

        const labelClasses = {
            'value-label': true,
            hidden: this.isLabelHidden,
        };

        return html`
            <div class="progress-bar-container">
                <div class="progress-bar" part="progress-bar">
                    <div class=${classMap(fillClasses)} style=${styleMap(fillStyles)}>
                        ${this.showValue
                            ? html`
                                  <div class="thumb-wrapper" style=${styleMap(thumbWrapperStyles)}>
                                      <div class="thumb"></div>
                                      <span class=${classMap(labelClasses)}>${this.currentFormat}</span>
                                  </div>
                              `
                            : ''}
                    </div>
                </div>
                <div class="progress-bar__limit-text" part="limit-text">
                    <span class="progress-bar__limit-title"> ${this.labelTitle} </span>
                    <span class="progress-bar__limit-value"> ${this.labelValue} </span>
                </div>
            </div>
        `;
    }
}
